/**
 * 동 표기 포맷 — 포레온스테이션5는 「동」 접미사 없이 표시
 */
export const formatBuildingLabel = (building, apartmentCode) => {
  if (building == null || building === "") return "-";
  if (apartmentCode === "ForeonStation5") return String(building);
  return `${building}동`;
};
